import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { StickyDiv } from 'shell/components/shared/sticky-div';

interface ButtonsProps {
  handleOpenModal: () => void;
}

const ButtonsComponent = ({ handleOpenModal }: ButtonsProps): React.ReactElement => {
  return (
    <StickyDiv>
      <StepButton active fullWidth>
        <StepTypography active>Cittadinanza</StepTypography>
      </StepButton>
      <div className="pmi-pt-4">
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="submit">
            Conferma
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="reset" id="reset">
            Ripulisci
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrand" variant="contained" fullWidth onClick={handleOpenModal}>
            Annulla Operazione
          </PmiButton>
        </div>
      </div>
    </StickyDiv>
  );
};

ButtonsComponent.displayName = 'Registration Citizenship page buttons component';

const Buttons = memo(ButtonsComponent);

export default Buttons;
